// Note: Google Maps API is no longer used directly
// This file is kept for backward compatibility with extractDataFromGooglePlaceResult
// New code should use PlacesService and extractDataFromPlaceDetails

import type { PlaceDetails } from '../api/services/PlacesService';

export const extractDataFromGooglePlaceResult = (place?: google.maps.places.PlaceResult) => {
  const obj: {
    zip?: google.maps.GeocoderAddressComponent;
    city?: google.maps.GeocoderAddressComponent;
    state?: google.maps.GeocoderAddressComponent;
    streetNumber?: google.maps.GeocoderAddressComponent;
    route?: google.maps.GeocoderAddressComponent;
    country?: google.maps.GeocoderAddressComponent;
    formattedAddress?: string;
  } = {};
  place?.address_components?.forEach((comp, i) => {
    if (comp.types.includes('locality')) {
      obj.city = place.address_components?.[i];
    }
    if (comp.types.includes('administrative_area_level_1')) {
      obj.state = place.address_components?.[i];
    }
    if (comp.types.includes('postal_code')) {
      obj.zip = place.address_components?.[i];
    }
    if (comp.types.includes('postal_code')) {
      obj.zip = place.address_components?.[i];
    }
    if (comp.types.includes('street_number')) {
      obj.streetNumber = place.address_components?.[i];
    }
    if (comp.types.includes('route')) {
      obj.route = place.address_components?.[i];
    }
    if (comp.types.includes('country')) {
      obj.country = place.address_components?.[i];
    }
  });
  if (place?.formatted_address) {
    obj.formattedAddress = place.formatted_address;
  }

  return obj;
};

// Extract data from backend PlaceDetails (replacement for Google Maps PlaceResult)
export const extractDataFromPlaceDetails = (place?: PlaceDetails) => {
  const obj: {
    zip?: { long_name: string; short_name: string; types: string[] };
    city?: { long_name: string; short_name: string; types: string[] };
    state?: { long_name: string; short_name: string; types: string[] };
    streetNumber?: { long_name: string; short_name: string; types: string[] };
    route?: { long_name: string; short_name: string; types: string[] };
    country?: { long_name: string; short_name: string; types: string[] };
    formattedAddress?: string;
  } = {};

  if (!place?.address_components) {
    return obj;
  }

  place.address_components.forEach((comp) => {
    if (comp.types.includes('locality')) {
      obj.city = {
        long_name: comp.long_name,
        short_name: comp.short_name,
        types: comp.types,
      };
    }
    if (comp.types.includes('administrative_area_level_1')) {
      obj.state = {
        long_name: comp.long_name,
        short_name: comp.short_name,
        types: comp.types,
      };
    }
    if (comp.types.includes('postal_code')) {
      obj.zip = {
        long_name: comp.long_name,
        short_name: comp.short_name,
        types: comp.types,
      };
    }
    if (comp.types.includes('street_number')) {
      obj.streetNumber = {
        long_name: comp.long_name,
        short_name: comp.short_name,
        types: comp.types,
      };
    }
    if (comp.types.includes('route')) {
      obj.route = {
        long_name: comp.long_name,
        short_name: comp.short_name,
        types: comp.types,
      };
    }
    if (comp.types.includes('country')) {
      obj.country = {
        long_name: comp.long_name,
        short_name: comp.short_name,
        types: comp.types,
      };
    }
  });

  if (place.formatted_address) {
    obj.formattedAddress = place.formatted_address;
  }

  return obj;
};
